/**
 * @fileoverview gRPC-Web generated client stub for InkCapture
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as icws_proto_icws_api_gateway_iam_get_licence_info_pb from '../../icws_proto/icws_api_gateway/iam/get_licence_info_pb';
import * as icws_proto_icws_api_gateway_iam_get_user_pb from '../../icws_proto/icws_api_gateway/iam/get_user_pb';
import * as icws_proto_icws_api_gateway_iam_update_user_pb from '../../icws_proto/icws_api_gateway/iam/update_user_pb';


export class IAMClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetUser = new grpcWeb.AbstractClientBase.MethodInfo(
    icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse,
    (request: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserRequest) => {
      return request.serializeBinary();
    },
    icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse.deserializeBinary
  );

  getUser(
    request: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse>;

  getUser(
    request: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse) => void): grpcWeb.ClientReadableStream<icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse>;

  getUser(
    request: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_get_user_pb.GetUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/InkCapture.IAM/GetUser',
        request,
        metadata || {},
        this.methodInfoGetUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/InkCapture.IAM/GetUser',
    request,
    metadata || {},
    this.methodInfoGetUser);
  }

  methodInfoUpdateUser = new grpcWeb.AbstractClientBase.MethodInfo(
    icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse,
    (request: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserRequest) => {
      return request.serializeBinary();
    },
    icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse.deserializeBinary
  );

  updateUser(
    request: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse>;

  updateUser(
    request: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse) => void): grpcWeb.ClientReadableStream<icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse>;

  updateUser(
    request: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_update_user_pb.UpdateUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/InkCapture.IAM/UpdateUser',
        request,
        metadata || {},
        this.methodInfoUpdateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/InkCapture.IAM/UpdateUser',
    request,
    metadata || {},
    this.methodInfoUpdateUser);
  }

  methodInfoGetLicenceInfo = new grpcWeb.AbstractClientBase.MethodInfo(
    icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse,
    (request: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoRequest) => {
      return request.serializeBinary();
    },
    icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse.deserializeBinary
  );

  getLicenceInfo(
    request: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoRequest,
    metadata: grpcWeb.Metadata | null): Promise<icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse>;

  getLicenceInfo(
    request: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse) => void): grpcWeb.ClientReadableStream<icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse>;

  getLicenceInfo(
    request: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: icws_proto_icws_api_gateway_iam_get_licence_info_pb.GetLicenceInfoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/InkCapture.IAM/GetLicenceInfo',
        request,
        metadata || {},
        this.methodInfoGetLicenceInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/InkCapture.IAM/GetLicenceInfo',
    request,
    metadata || {},
    this.methodInfoGetLicenceInfo);
  }

}

